import { SvgIcon, SvgIconProps } from "@mui/material";

const StatisticIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g id="SVGRepo_bgCarrier" strokeWidth="0" />
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" />
      <g id="SVGRepo_iconCarrier">
        <path d="M20,3H4A3,3,0,0,0,1,6V18a3,3,0,0,0,3,3H20a3,3,0,0,0,3-3V6A3,3,0,0,0,20,3Zm1,15a1,1,0,0,1-1,1H4a1,1,0,0,1-1-1V6A1,1,0,0,1,4,5H20a1,1,0,0,1,1,1ZM9,12v4a1,1,0,0,1-2,0V12a1,1,0,0,1,2,0Zm4-2v6a1,1,0,0,1-2,0V10a1,1,0,0,1,2,0Zm4-2v8a1,1,0,0,1-2,0V8a1,1,0,0,1,2,0Z" />
      </g>
    </SvgIcon>
  );
};

export default StatisticIcon;
